/* eslint-disable no-undef */
import { useState } from 'react';

export const useFormState = () => {
  // Main form state object to track all selections
  const [formData, setFormData] = useState<{
    compensationElements: number[];
    demographics: any[];
    groups: {
      id: string | number;
      name: string;
      fields: any[];
    }[];
  }>({
    compensationElements: [], // Store selected compensation IDs
    demographics: [], // Store selected demographic IDs
    groups: [
      {
        id: self.crypto.randomUUID(),
        name: '',
        fields: [], // Store dropdown selections for each group
      },
    ],
  });

  // Update compensation selections
  const updateCompensation = (selectedIds: number[]) => {
    setFormData((prev) => ({
      ...prev,
      compensationElements: selectedIds,
    }));
  };

  // Update demographics selections
  const updateDemographics = (selectedIds: number[]) => {
    setFormData((prev) => ({
      ...prev,
      demographics: selectedIds,
    }));
  };

  // Update group data
  const updateGroup = (groupId: number | string, updates: any) => {
    setFormData((prev) => ({
      ...prev,
      groups: prev.groups.map((group) => (group.id === groupId ? { ...group, ...updates } : group)),
    }));
  };

  // Add new group
  const addGroup = () => {
    setFormData((prev) => ({
      ...prev,
      groups: [
        ...prev.groups,
        {
          id: self.crypto.randomUUID(),
          name: '',
          fields: [],
        },
      ],
    }));
  };

  const removeGroup = (groupId: string) => {
    setFormData((prev) => ({ ...prev, groups: prev.groups.filter((item) => item.id !== groupId) }));
  };

  return {
    formData,
    updateCompensation,
    updateDemographics,
    updateGroup,
    addGroup,
    removeGroup,
  };
};
